<template>
  <div id="targetbox">
		<div class="work_wrap">
		  <div class="flex work_menu1">
			<div class="work_listtitle">职业类型：</div>
			<ul class="flex work_position">
			  <li v-for="(item, index) in jobTypeList" :key="index"
				:class="positionId==item.typeId?'work_active':''" @click="changePosition(item)">{{item.typeName}}</li>
			</ul>
		  </div>
		  <div class="flex work_menu1">
			<div class="work_listtitle">发布时间：</div>
			<ul class="flex work_position">
			  <li v-for="(item, index) in publishTimeList" :key="index"
			  :class="releaseCode==item.code?'work_active':''" @click="changeRelease(item)">{{item.desc}}</li>
			</ul>
		  </div>
			<p class="work_menu3">全部职位（共{{workParams.total}}个）</p>
		  <div class="work_info">

			<div class="work_table">
			  <el-table :show-header="false" :data="workList" style="width: 100%">
				<el-table-column label="职位名称" min-width="25%">
					<template slot-scope="scope">
						<span class="font18">{{ scope.row.jobName }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="jobName" label="学历要求" min-width="30%" align="center">
					<template slot-scope="scope">
					  <span>{{scope.row.jobExperience}}</span> |
					  <span>{{scope.row.educationName}}</span> |

					  <span v-if="scope.row.jobMethod==0">兼职</span>
					  <span v-else-if="scope.row.jobMethod==1">全职</span>
					  <span v-else-if="scope.row.jobMethod==2">兼职/全职</span>
					</template>
				</el-table-column>
        <el-table-column prop="jobSalaryMin" min-width="30%" align="center">
          <template slot-scope="scope">{{scope.row.jobSalaryMin}}K-{{scope.row.jobSalaryMax}}K</template>
        </el-table-column>
				<el-table-column prop="updateTime" min-width="30%" align="center">
				</el-table-column>
				<el-table-column min-width="15%" align="right" type="expand">
				  <template slot-scope="scope">
					<p class="font18 work_infotitle">岗位职责：</p>
					<div class="work_content" v-html="scope.row.jobDesc"></div>
					<p class="font18 work_infotitle">任职资格：</p>
					<div class="work_content" v-html="scope.row.jobCondition"></div>
					<div class="flexbet delivery_down">
					  <div class="rightaway_delivery font18" @click="deliverylistJob(scope.row)">立即投递</div>
					  <div class="check_info" @click="watchInfo(scope.row)">查看详情</div>
					</div>
				  </template>
				</el-table-column>
			  </el-table>
			</div>
			<div class="flexcenter work_pages">
			  <el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="currentPage4"
				:page-size="10"
				layout="total, sizes, prev, pager, next, jumper"
				:total="workParams.total">
			  </el-pagination>
			</div>
		  </div>
    </div>
	<div class="work_smallwrap" v-if="workList.length>0">
		<div class="flexbet">
			<p class="work_menu3">全部职位（共{{workParams.total}}个）</p>
			<div class="gflex">
				<div class="gflex worksmall_menu" @click="showJobtime = true">{{releaseTime}}
					<span class="el-icon-arrow-down"></span>
				</div>
				<div class="gflex worksmall_menu" @click="showJoblist = true">{{positionDesc}}
					<span class="el-icon-arrow-down"></span>
				</div>
			</div>
		</div>
		<div class="worksmall_table">
			<div class="flexbet worksmall_tr" v-for="(item, index) in workList" :key="index"
				@click="watchInfo(item)">
				<div>
					<div class="worksmall_name">{{item.jobName}}</div>
					<div>
						<span>{{item.jobExperience}}</span> |
						<span>{{item.educationName}}</span> |

						<span v-if="item.jobMethod==0">兼职</span>
						<span v-else-if="item.jobMethod==1">全职</span>
						<span v-else-if="item.jobMethod==2">兼职/全职</span>
					</div>
				</div>
				<div class="worksmall_salary">{{item.jobSalaryMin}}K-{{item.jobSalaryMax}}K</div>
			</div>
      <!-- <div class="smallpage flexcenter">
        <div class="flex">
          <van-pagination
            @change="handleCurrentChange"
            v-model="currentPage4"
            :total-items="workParams.total"
            :show-page-size="3"
            force-ellipses
          />
        </div>
      </div> -->
      <div class="flexcenter hot_next" @click="nextList" v-if="!nomore">下一页
        <span class="iconfont icon-xiayiye"></span>
      </div>
      <div class="worksmall_yq" v-else>没有更多了～</div>
		</div>
		<van-popup v-model="showJoblist" position="bottom">
			<van-picker show-toolbar :columns="columnsJob"
			 @confirm="onConfirmjobtype" @cancel="showJoblist=false"/>
		</van-popup>
		<van-popup v-model="showJobtime" position="bottom">
			<van-picker show-toolbar :columns="columnsTime"
			 @confirm="onConfirmjobtime" @cancel="showJobtime=false"/>
		</van-popup>
	</div>
  </div>
</template>

<script>
	import { getinitemploymentapi, jobPageListapi } from "@/api/apilist/commonApi";
	import { zyType, experienceType } from "@/utils";
  export default {
	  props:{
		  windowWidth: {
			  type: Number,
			  default: 1200,
		  },
      pageTop: {
        type: Boolean,
        default: false,
      }
	  },
    data() {
      return {
			showJobtime: false,
			showJoblist: false,
			columnsJob: [],
			columnsTime: [],
			jobTypeList: [{typeName: '全部', typeId: ''}],
			positionId: '',
			publishTimeList: [],
			releaseCode: 0,
			jobInfo: {},
			workList: [],
			currentPage4: 1,
			workParams: {
				pageNum: 1,
				pageSize: 10,
				total: 0,
				pages: 1,
			},
			nomore: false,//没有更多了
			releaseTime: '发布时间',
			positionDesc: '职位类别',
		};
    },
    created() {
      this.getinitemployment();
    },
    methods:{
		onConfirmjobtime(val){
			this.releaseTime = val;
			this.publishTimeList.forEach((item)=>{
				if(val==item.desc){
					this.releaseCode = item.code;
				}
			})
      this.workParams.pageNum = 1;
			this.workParams.total = 0;
			this.workList = [];
			this.nomore = false;
			this.getjobPageList();
			this.showJobtime = false;
		},
		onConfirmjobtype(val){
			this.positionDesc = val;
			this.jobTypeList.forEach((item)=>{
				if(val==item.typeName){
					this.positionId = item.typeId;
				}
			})
      this.workParams.pageNum = 1;
			this.workParams.total = 0;
			this.workList = [];
			this.nomore = false;
			this.getjobPageList();
			this.showJoblist = false;
		},
		deliverylistJob(row){
			this.$emit('deliverylistJob', row)
		},
		watchInfo(row){
			this.$emit('watchInfo',row)
		},
		getinitemployment() {
			getinitemploymentapi().then(res=>{
				if(res.data){
          this.releaseCode = res.data.publishTimeList[0].code;
          this.columnsTime = [];
          res.data.publishTimeList.forEach((item)=>{
            this.columnsTime.push(item.desc)
          })
          this.publishTimeList = res.data.publishTimeList;
          if(res.data.jobTypeList.length>0){
            this.columnsJob = ['全部'];
            this.positionId = '';
            res.data.jobTypeList.forEach((item)=>{
              this.columnsJob.push(item.typeName)
              item.label = item.jobName;
              item.value = item.jobId;
            })
            this.jobTypeList = this.jobTypeList.concat(res.data.jobTypeList);
            this.getjobPageList();
          }

				}
			})
		},

		getjobPageList(val) {
			this.workParams.publishTimeCode = this.releaseCode;
			this.workParams.typeId = this.positionId;
			jobPageListapi(this.workParams).then(res=>{
        this.workParams.total = Number(res.data.total);

				if(res.data.list.length>0){
					res.data.list.forEach((item)=>{
						item.updateTime = item.updateTime.slice(0, 10);
						item.educationName = zyType(item.jobEducation);
						item.jobExperience = experienceType(item.jobYearMin, item.jobYearMax);
            item.jobSalaryMin = item.jobSalaryMin/1000;
            item.jobSalaryMax = item.jobSalaryMax/1000;
					})

					if(res.data.list.length<10){
						if(this.workParams.pageNum==1){
							this.nomore = false;
						}else{
							this.nomore = true;
						}
					}
				}else{
					if(this.workParams.pageNum>1){
						this.nomore = true;
					}
				}
        if(val){
          this.workList = this.workList.concat(res.data.list);
        }else{
          this.workList = res.data.list;
        }
        if(this.pageTop){

          this.$nextTick(() => {
            setTimeout(() => {
              let targetbox = document.getElementById('targetbox');
              document.documentElement.scrollTop = targetbox.offsetTop;
            },100)
          })
        }
			})
		},
		// 下一页
		nextList(){
			this.workParams.pageNum+=1;
			this.getjobPageList(2);
		},
      changeRelease(item){
        this.releaseCode = item.code;
        this.workParams.pageNum = 1;
        this.workParams.total = 0;
        // this.workList = [];
        this.nomore = false;
        this.getjobPageList();
      },
      changePosition(item){
        this.positionId = item.typeId;
        this.workParams.pageNum = 1;
        this.workParams.total = 0;
        // this.workList = [];
        this.nomore = false;
        this.getjobPageList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        this.workParams.pageNum = val;
        setTimeout(() => {
          let targetbox = document.getElementById('targetbox');
          document.documentElement.scrollTop = targetbox.offsetTop;
        },100)
        this.getjobPageList();
      },
    }
  }
</script>

<style scoped lang="less">
  @media screen and (max-width: 480px){
    .smallpage{margin: 20px auto 50px;
      ::v-deep .van-pagination__item{color: #D9BF81;}
      ::v-deep .van-pagination__item--active{color: #fff;background-color: #D9BF81;}
    }
	  .work_wrap{display: none;}
	  .work_smallwrap{
		  padding-top: 56px;
		  font-size: 14px;
	  }
    .worksmall_salary{font-size: 15px;font-weight: bold;text-align: right;}
    .work_menu3{font-size: 14px;}
	.hot_next{width: 100%;height: 40px;background-color: #F2F2F2;border-radius: 5px;
	  margin-bottom: 50px;
	  margin-top: 30px;
	  span{margin-left: 10px;}
	}
	.worksmall_menu{
		  background-color: #F2F2F2;
		  text-align: center;
		  padding: 0 10px;
		  height: 30px;
		  line-height: 30px;
		  border-radius: 3px;
		  margin-left: 10px;
	}
	.worksmall_table{
		  margin-top: 10px;
	}
	.worksmall_tr{
		  border-top: 1px solid #F2F2F2;
		  padding: 10px 0;
		  font-size: 14px;
		  cursor: pointer;
		  .worksmall_name{
			  font-size: 18px;
			  margin-bottom: 5px;
        width: 270px;
        font-weight: bold;
		  }
	}
	.worksmall_yq{color: #999;text-align: center;margin: 30px auto 50px;}
  }
  @media screen and (min-width: 481px){
    .work_smallwrap{display: none;}
    .work_listtitle{width: 100px;line-height: 40px;}
  }

  .font18{font-size: 18px;font-weight: bold;color: #333;}
  .work_wrap{
    padding-top: 100px;
    font-size: 16px;
    .work_info{
      .work_pages{margin: 52px 0 100px;
        ::v-deep .el-input__inner{border-color: #DCC691;}
        ::v-deep .number{border: 1px solid #DCC691;font-weight: normal;margin: 0 5px;font-size: 13px;}
        ::v-deep .el-pager li.active{color: #fff;background-color: #DCC691;}
        ::v-deep .el-pagination__sizes{display: none;}
      }
      .work_table{
        border-top: 1px solid #EBEEF5;
		::v-deep .el-icon-arrow-right{transform: rotate(90deg);margin-left: -10px;}
		::v-deep .el-table__expand-icon--expanded{
			transform: rotate(180deg);
			// .el-icon-arrow-right:before{content: "\e6d8";}
		}
    ::v-deep .el-table{color: #333;}
		::v-deep .el-table__expand-icon>.el-icon{top: 35%;}
		::v-deep .el-icon-arrow-right{font-size: 20px;font-weight: bold;}

      }
      .work_infotitle{margin: 25px 0 10px;}
      .work_content{
        line-height: 50px;
      }
      .delivery_down{margin: 20px 0 49px;}
      .rightaway_delivery{
        width: 120px;
        height: 40px;
        line-height: 40px;
        color: #fff;
        text-align: center;
        background-color: #DCC691;
        border-radius: 20px;
		cursor: pointer;
      }
      .check_info{color: #DCC691;font-size: 18px;cursor: pointer;}
    }
    .work_menu1{
      margin-bottom: 38px;
    }
    .work_menu2{margin-bottom: 50px;}
    .work_menu3{font-size: 16px;margin-bottom: 18px;}
  }
  .work_listtitle{font-size: 18px;font-weight: bold;}
  .work_position{
    text-align: center;
    font-size: 18px;
    margin-left: 50px;
    flex-wrap: wrap;
    li{
      padding: 0 20px;
      height: 40px;
      border-radius: 20px;
      line-height: 40px;
      cursor: pointer;
      margin-right: 20px;
      margin-bottom: 20px;
    }
    .work_active{color: #fff;background-color: #DCC691;}
  }

</style>
